// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2pG9y","title":"Info_title__2Ma2P","selects":"Info_selects__1uswC","requiredAsterisk":"Info_requiredAsterisk__-0itH"};